import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="app-footer">
            <img src="/lakota-logo.png" alt="Lakota Software Solutions Logo" className="footer-logo" />
            <p>&copy; {currentYear} Lakota Software Solutions, Inc. All Rights Reserved.</p>
        </footer>
    );
};

export default Footer;